import isObject from 'lodash/isObject.js';
import isFunction from 'lodash/isFunction.js';

/**
 * Tests if a given value meets the Promise interface
 *
 * @function isPromise
 * @param {any} input Value to test
 * @returns {boolean}
 * @category Types
 */
export default function isPromise(input) {
  // @ts-ignore
  return isObject(input) && isFunction(input.then);
}
